import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { z } from "zod";
import { getAuthHeader } from "../../../../utils/superagent";
import request from "superagent";

export const ExtraTimePayOptionsSchema = z.object({
  threshold: z.number(),
  multiplier: z.number(),
});

export type ExtraTimePayOptions = z.infer<typeof ExtraTimePayOptionsSchema>;

export const ExtraTimePaySettingsSchema = z.object({
  _id: z.string(),
  facilityId: z.string(),
  workdayOptions: z.array(ExtraTimePayOptionsSchema).nullable(),
  weeklyOption: ExtraTimePayOptionsSchema.nullable(),
  isEditableByFacility: z.boolean(),
  createdAt: z.string().transform((v) => new Date(v)),
  updatedAt: z.string().transform((v) => new Date(v)),
});

export type ExtraTimePaySettings = z.infer<typeof ExtraTimePaySettingsSchema>;

export const LOAD_ETP_SETTINGS_QUERY_KEY = "LOAD_ETP_SETTINGS_QUERY";

export function useLoadEtpSettings(facilityId: string): UseQueryResult<ExtraTimePaySettings> {
  return useQuery({
    queryKey: [LOAD_ETP_SETTINGS_QUERY_KEY, facilityId],
    queryFn: async () => {
      const response = await request
        // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
        .get(`${global.api}/facilities/${facilityId}/extra-time-pay-settings`)
        .set(await getAuthHeader());

      if (!response.ok) {
        throw new Error(`${response.statusCode}: Problem fetching ETP settings for facility.`);
      }

      return ExtraTimePaySettingsSchema.parse(response.body.data);
    },
  });
}
